import { useLazyQuery } from "@apollo/client/react";
import { FormControl, Grid, InputAdornment, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { DateInput } from '../../../components/dateInput/DateInput';
import { CustomButton } from '../../../components/customButton/CustomButton';
import SearchIcon from '@mui/icons-material/Search';
import { GET_DELEGACIONES_BY_USUARIO } from '../../../data/graphQL/queries/PacienteProbable/getAllDelegacionesByUsuario';
import { adaptDelegacionArray } from '../../../adapters/delegacionAdapter';
import { GET_USUARIO_DELEGACION_ORIGEN } from '../../../data/graphQL/queries/usuarios/getUsuarioDelegacionOrigen';
import moment from 'moment';
import toast from 'react-hot-toast';
import { CompareDates } from '../../../utils/helpers';
import { GET_IMPRIMIR_VISITAS, adaptImprimirVisitasArray } from '../../../data/graphQL/queries/ImprimirVisita/getImprimirVisitas';
import { GET_ALL_TIPO_PROFESIONALES } from '../../../data/graphQL/queries/PlanCuidado/getTipoProfesionales';
import { adaptTipoProfesionalArray } from '../../../adapters/tipoProfesionalAdapter';

export const ImprimirVisitaGrillaFilters = ({
  delegaciones,
  tipoProfesionales,
  filters,
  printLoading,
  setImprimirVisitasGrilla,
  setImprimirVisitasGrillaLoading,
  setDelegaciones,
  setTipoProfesionales,
  handleChangeFilters,
  refetchGrilla,
  setRefetchGrilla
}) => {
  const storageId = sessionStorage.getItem('idUsuario');
  const [delegacionOrigen, setDelegacionOrigen] = useState(0);
  const [datosOriginal, setDatosOriginal] = useState([]);
  const [textFilter, setTextFilter] = useState(null);
  const txtFiltro = useRef(null);

  useEffect(() => {
    if (!delegacionesLoading)
      getDelegaciones({variables: { idUsuario: JSON.parse(storageId, 10) }});
    if (!tipoProfesionalesLoading)
      getTipoProfesionales();
  }, []);

  const [getDelegaciones, { data: delegacionesData, loading: delegacionesLoading }] = useLazyQuery(GET_DELEGACIONES_BY_USUARIO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!delegacionesData) return;
    setDelegaciones(adaptDelegacionArray(delegacionesData));
  }, [delegacionesData]);

  const [getTipoProfesionales, { data: tipoProfesionalesData, loading: tipoProfesionalesLoading }] = useLazyQuery(GET_ALL_TIPO_PROFESIONALES, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!tipoProfesionalesData) return;
    setTipoProfesionales(adaptTipoProfesionalArray(tipoProfesionalesData));
  }, [tipoProfesionalesData]);

  useEffect(() => {
    if (delegaciones != null && !delegacionOrigenLoading)
      getDelegacionOrigen({variables: { idUsuario: JSON.parse(storageId, 10) }});
  }, [delegaciones]);

  const [getDelegacionOrigen, { data: delegacionOrigenData, loading: delegacionOrigenLoading }] = useLazyQuery(GET_USUARIO_DELEGACION_ORIGEN, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!delegacionOrigenData) return;
    if (delegacionOrigenData.usuarioFull.success) {
      const deleg = parseInt(delegacionOrigenData.usuarioFull.valorEsperado.delegacionOrigen, 10);
      setDelegacionOrigen(deleg);
      handleChangeFilters('idDelegacion', localStorage.getItem('ImprimirVisitaGrillaFilters') != null && filters.idDelegacion > 0 ? filters.idDelegacion : deleg);
    }
  }, [delegacionOrigenData]);

  useEffect(() => {
    if (refetchGrilla && !ImprimirVisitasGrillaLoading)
      handleSearch();
  }, [refetchGrilla]);

  const [getImprimirVisitas, { data: dataImprimirVisitas, loading: ImprimirVisitasGrillaLoading }] = useLazyQuery(GET_IMPRIMIR_VISITAS, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataImprimirVisitas) return;
    setImprimirVisitasGrillaLoading(false);
    const regs = adaptImprimirVisitasArray(dataImprimirVisitas.impresionVisitas.valorEsperado);
    setDatosOriginal(regs);
    setImprimirVisitasGrilla(regs);      
    setRefetchGrilla(false);    
  }, [dataImprimirVisitas]);

  useEffect(() => {
    if (datosOriginal.length > 0) handleTextFilter();   
  }, [datosOriginal]);

  const validateFilters = () => {
    if (filters.idDelegacion <= 0)
    {
      toast.error("La Delegación es obligatoria.");
      return false;
    }

    if (filters.fechaDesde == "" || filters.fechaHasta == "") {
      toast.error("La Fecha desde y la Fecha hasta son obligatorias.");
      return false;
    }

    if (CompareDates(filters.fechaDesde, filters.fechaHasta) === 1) {
      toast.error("La Fecha desde no puede ser posterior a la Fecha hasta.");
      return false;
    }

    if (CompareDates(filters.fechaHasta, moment().format("YYYY-MM-DD")) === 1) {
      toast.error("La Fecha hasta no puede ser posterior a la fecha actual.");
      return false;
    }

    if (filters.idTipoProfesional <= 0)
    {
      toast.error("El Tipo de Profesional es obligatorio.");
      return false;
    }

    return true;
  };

  const handleSearch = () => {
    setImprimirVisitasGrilla([]);
    if (!ImprimirVisitasGrillaLoading && validateFilters()) {
      setImprimirVisitasGrillaLoading(true);
      getImprimirVisitas({ variables: 
        { filter: {
          fechaDesde: filters.fechaDesde,
          fechaHasta: filters.fechaHasta,
          idDelegacion: filters.idDelegacion,
          idTipoProfesional: filters.idTipoProfesional
        } } 
      });
    }
  };

  const handleTextFilter = () => {
    const inputBuscar = filters?.txtFiltro.toString().toUpperCase();

    if (inputBuscar?.length >= 2) {
      setImprimirVisitasGrilla(datosOriginal?.filter((datoOriginal) => {
        const visitaBuscar = datoOriginal.idVisita.toString();
        const tipoDocumento = datoOriginal.tipoDocumento.toString().toUpperCase();
        const tipoBuscar = datoOriginal.tipoVisita.toString().toUpperCase();
        const hcBuscar = datoOriginal.idPaciente.toString();
        const pacienteBuscar = datoOriginal.paciente.toUpperCase();
        const profesionalBuscar = datoOriginal.profesional.toUpperCase();
        const contratoBuscar = datoOriginal.idEvaluacion.toString();
        const clienteBuscar = datoOriginal.cobertura.toString();
        const programaBuscar = datoOriginal.programa.toUpperCase();

        return (
          visitaBuscar.includes(inputBuscar) ||
          tipoDocumento.includes(inputBuscar) ||
          tipoBuscar.includes(inputBuscar) ||
          hcBuscar.includes(inputBuscar) ||
          pacienteBuscar.includes(inputBuscar) ||
          profesionalBuscar.includes(inputBuscar) ||
          contratoBuscar.includes(inputBuscar) ||
          clienteBuscar.includes(inputBuscar) ||
          programaBuscar.includes(inputBuscar));

      }));
    } else {
      setImprimirVisitasGrilla(datosOriginal);
    }
  };

  const handleChangeFecha = (name, value) => {
    handleChangeFilters(name, moment(value).isValid() ? moment(value).format("YYYY-MM-DD") : '');
  };

  return (
    <>
            <Grid container spacing={2}>
                <Grid size={{ md: 2 }}>
                    <FormControl sx={{ backgroundColor: 'white', width: '100%' }} size="small">
                        <InputLabel id="select-delegacion">Delegación</InputLabel>
                        <Select
              labelId="select-delegacion"
              options={delegaciones}
              label='Delegación'
              onChange={(e) => {
                handleChangeFilters('idDelegacion', e.target.value);
              }}
              value={filters?.idDelegacion}
              name='idDelegacion'>
              
                            {delegaciones && delegaciones.map((delegacion) => {
                return delegacion.id > 0 && <MenuItem key={delegacion.id} value={delegacion.id}> {delegacion.displayName} </MenuItem>;
              })}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid size={{ md: 1.8 }}>
                    <DateInput
            label="Fecha Desde"
            value={filters?.fechaDesde}
            onChange={(value) => handleChangeFecha("fechaDesde", value)}
            name="fechaDesde" />
          
                </Grid>
                <Grid size={{ md: 1.8 }}>
                    <DateInput
            label="Fecha Hasta"
            value={filters?.fechaHasta}
            onChange={(value) => handleChangeFecha("fechaHasta", value)}
            name="fechaHasta" />
          
                </Grid>
                <Grid size={{ md: 2 }}>
                    <FormControl sx={{ backgroundColor: 'white', width: '100%' }} size="small">
                        <InputLabel id="select-tipo-profesional">Tipo Profesional</InputLabel>
                        <Select
              labelId="select-tipo-profesional"
              options={tipoProfesionales}
              label='TipoProfesional'
              onChange={(e) => {
                handleChangeFilters('idTipoProfesional', e.target.value);
              }}
              value={filters?.idTipoProfesional}
              name='idTipoProfesional'>
              
                            {tipoProfesionales && tipoProfesionales.map((tipoProfesional) => {
                return tipoProfesional.id > 0 && <MenuItem key={tipoProfesional.id} value={tipoProfesional.id}> {tipoProfesional.displayName} </MenuItem>;
              })}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid size={{ md: 3 }}>
                    <TextField
            label="Filtrar"
            name="txtFiltro"
            size="small"
            type="text"
            variant="outlined"
            value={filters?.txtFiltro}
            // onChange={(e) => setTextFilter(e.target.value)}
            onChange={(e) => {
                handleChangeFilters('txtFiltro', e.target.value);
              }}
            onKeyUp={handleTextFilter}
            sx={{ backgroundColor: 'white', width: '100%' }}
            InputProps={{
              endAdornment:
              <InputAdornment position="end">
                                    <SearchIcon
                  onClick={handleTextFilter}
                  sx={{ cursor: 'pointer' }} />
                
                                </InputAdornment>

            }} />
          
                </Grid>
                <Grid size={{ md: 1.2 }}>
                    <CustomButton
            className='margin-right'
            disabled={printLoading}
            isLoading={ImprimirVisitasGrillaLoading}
            onClick={handleSearch}
            size='small'
            variant='contained'>
            
                        Buscar
                    </CustomButton>
                </Grid>
            </Grid>
        </>);

};